<template>
  <div class="item-container">
    <img
      class="item-title"
      src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/0c1dfae7b1e7bf72486c00a1f3e498fb_wh=807_252.webp"
      alt=""
    />
    <div class="item">
      <div class="right-container">
        <img
          class="item-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/bccd99f23f07e38bf1c0bdef73251382_wh=1101_1629.webp"
          alt=""
        />
        <div class="btn ai-btn" @click="bindJumpAi"></div>
      </div>
      <img
        class="item-image"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/2c4c698fb99c895a98ca051072ef0387_wh=1101_2637.webp"
        alt=""
      />
      <img
        class="item-image image-margin"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/99aa8dda9fafb23c772253217ab3acc2_wh=1101_1314.webp"
        alt=""
      />
      <div class="item-padding">
        <div class="right-container">
          <img
            class="item-image image-margin"
            src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/cfe0d423e6e9c84d1ee4d7be80e6274f_wh=1041_1506.webp"
            alt=""
          />
          <div class="btn consult-btn" @click="bindConsult"></div>
        </div>
      </div>
      <div class="item-padding">
        <img
          class="item-image image-margin"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/aca4cba2e23959a133db33859778a9fe_wh=1041_2565.webp"
          alt=""
        />
      </div>
      <!--  <div class="item-padding right-container image-margin">
        <img
          class="item-image"
          src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/e91752a4a60bc09fe004eaf600f23648_wh=1041_1506.png"
          alt=""
        />
        <div class="btn" @click="bindConsult"></div>
      </div> -->
      <div class="item-padding">
        <div class="right-container image-margin">
          <img
            class="item-image"
            src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/ac7367bcfe864bb8aefb322597d37ae9_wh=1041_1224.webp"
            alt=""
          />
          <div class="btn" @click="bindClick"></div>
        </div>
        <!--  <img
          class="item-image image-margin"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0d67857a1ad76a3e7cd48b270ba498d9.png"
          alt=""
        /> -->
      </div>
      <img
        class="item-title item-title-1"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/b3d87ad20a8d523f323edce81a930a55_wh=864_318.webp"
        alt=""
      />
      <div class="item-padding">
        <div class="right-container image-margin">
          <img
            class="item-image"
            src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-12/7e6d7aee138327469db656b1a8a743c9_wh=1041_2556.webp"
            alt=""
          />
          <div class="btn buy-btn" @click="bindToVip"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick() {
      this.$betterwe.vipHomePage({ isLogin: 1 })
    },
    bindToVip() {
      this.$betterwe.vipHomePage({
        card_type_attr: 2,
        vip_type_id: 3,
        isLogin: 1
      })
    },
    bindJumpAi() {
      let url =
        '/web?url=' +
        encodeURIComponent(
          'https://btvue.gymcity.com.cn/lowcode-active?pageid=290'
        )
      this.$betterwe.jumpRoute(url)
    },
    bindConsult() {
      let url =
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fbtw-common-data-oss.betterwestar.com%252Fbtw-admin%252Fresource%252F2ad59f26be4f0f467fc8b3f8c746381d_wh%253D750_1448.png'
      this.$betterwe.jumpRoute(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.item-padding {
  padding: 0px 10px;
}
.item-title {
  margin: 0 auto;
  width: 269px;
  height: 94px;
  object-fit: contain;
  position: relative;
  z-index: 1;
}
.item-title-1 {
  width: 287px;
  height: 106px;
}
.item {
  margin-top: -13px;
  position: relative;
  margin-bottom: 50px;
  padding: 0px 4px;
  .item-image {
    width: 100%;
  }

  .image-margin {
    margin-bottom: 16px;
  }

  .right-container {
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    .btn {
      position: absolute;
      left: 50%;
      bottom: 24px;
      transform: translate(-50%, 0%);
      width: 241px;
      height: 40px;
      border-radius: 30px;
      font-weight: bold;
      font-size: 20px;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
    }
    .buy-btn {
      bottom: 21px;
      width: 290px;
      height: 51px;
    }
    .ai-btn {
      bottom: 34px;
    }
    .consult-btn {
      bottom: 40px;
    }
  }
}
</style>
